import { render } from "./MyReferrals.vue?vue&type=template&id=f3618a50"
import script from "./MyReferrals.vue?vue&type=script&lang=js"
export * from "./MyReferrals.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__